import { Injectable } from '@angular/core';
import { EntityStore } from '@examdojo/state';
import { QuestionEntityState, QuestionEntityStoreModel } from './models';

@Injectable({ providedIn: 'root' })
export class QuestionEntityStore extends EntityStore<QuestionEntityState, QuestionEntityStoreModel, 'id'> {
  constructor() {
    super({
      name: 'question-entity',
      idKey: 'id',
    });
  }
}
